var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsaMade = function SvgUsaMade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 227,
    fill: "none",
    viewBox: "0 0 541 547"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E91533",
    d: "M263 539c-1-1-49-37-112-38-75-1-112-52-118-62-9-9-41-55-2-170 35-105-14-139-16-141l-15-9 13-13L118 0l10 9s29 24 68 24c24 0 47-9 69-26l9-7 9 7s34 26 76 26c22 0 43-8 62-23l10-8 109 116-7 10c-9 12-32 48-32 71 0 31 13 78 20 101 8 23 23 100-18 147-41 46-80 53-120 56-38 3-85 19-101 35l-9 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M152 451c51 1 94 20 119 34 28-15 71-28 108-31 29-3 57-7 86-40 9-10 13-24 14-37 4-25-1-51-5-61-9-26-23-81-23-117 0-21 14-52 26-75l-53-57c-20 11-42 16-65 16-34 0-64-12-84-23a154 154 0 0 1-151 5l-52 52c9 14 17 35 20 62 3 26 1 61-14 106-12 35-16 63-16 84 0 22 5 34 8 37l2 2 3 4c4 7 28 38 77 39m0-20c49 1 92 18 119 32 30-14 70-26 107-29 23-2 48-5 72-33 6-7 8-17 10-26 2-22-2-44-5-53-9-27-24-85-24-123 0-20 10-48 22-72l-34-36q-28.5 12-60 12c-32 0-62-10-83-20a172 172 0 0 1-148 6l-31 32c7 14 13 33 15 56 3 28 1 66-15 114v1c-11 32-15 57-15 77q0 19.5 3 24l5 5v1l2 2c3 5 23 29 60 30",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M231 144v18c0 7 6 13 13 13s13-6 13-13v-18l-1-1h-5a1 1 0 0 0-1 1v18c0 3-3 6-6 6s-6-3-6-6v-18a1 1 0 0 0-1-1h-5zm30 26v2c1 1 5 3 10 3 7 0 11-5 11-9 0-6-6-9-9-10-4-2-5-3-5-5 0-1 1-2 3-2l6 3 2-1 2-3v-2c-1-1-5-3-10-3-7 0-10 4-10 9s5 8 9 10c3 1 4 2 4 4s-1 3-3 3l-6-3-2 1zm23 5-1-1 14-31h2l14 31-1 1h-5l-1-1-2-4h-12l-2 4-1 1zm14-18 3 7h-7l3-7z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E91533",
    d: "M51 204h445v180H51z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m139 225 20 11c7-6 18-10 24-10 9 0 14 7 14 14 10-9 22-14 29-14 10 0 14 7 14 15 0 5-2 11-5 19l-28 69c-3 8-3 12 5 16l-7 18c-23-7-26-23-20-38l22-56c4-8 6-15 6-18q0-3-3-3c-4 0-12 5-18 13l-29 70h-24l25-62c4-8 6-15 6-18q0-3-3-3c-4 0-11 4-18 11l-29 72H97l33-83c-22 7-39 10-39 20 0 6 7 6 9 6v20c-17 0-29-10-29-26 0-28 34-31 68-43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M243 331c12 0 22-11 22-11s2 11 17 11c17 0 30-15 41-34-1-2-5-5-8-5-10 16-19 24-24 24-2 0-4-1 2-17l16-39h-24l-3 9s-4-11-17-11c-27 0-38 40-38 55 0 10 5 18 16 18m24-27s-6 9-13 9c-2 0-4-1-4-5 0-8 9-31 19-31 6 0 6 7 6 7z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M325 331c12 0 22-11 22-11s2 11 17 11c17 0 30-15 41-34-1-2-5-5-8-5-10 16-19 24-23 24-3 0-5-1 1-17l27-66h-24l-14 36s-4-11-17-11c-25 0-38 40-38 55 0 9 5 18 16 18m23-27s-5 9-13 9c-2 0-4-1-4-5 0-8 9-31 19-31 6 0 6 7 6 7z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M475 297c-1-2-5-5-8-5-9 16-24 24-38 24-17 0-14-11-14-11 27 3 37-6 43-17 8-21-7-30-22-30-31 0-44 31-44 48 0 15 10 25 30 25 27 0 44-18 53-34m-57-5s7-16 16-16c4 0 3 4 2 6-2 6-6 12-18 10",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M250 233h116v3H250zM89 349h87v3H89zm141 0h229v3H230zm183-116h40v3h-40z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m273 416-19 14 7-22-18-14h23l7-22 7 22h23l-18 14 7 22z",
    clipRule: "evenodd"
  })));
};
export default SvgUsaMade;